import React from "react";
import Core from "../components/Core";
import Template900Component from "./Template900Component";

import screenProvider from "../services/CommonScreenProvider";
import dataProvider from "../services/CommonDataProvider";
import { baseEventHandler } from "../services";

export default class Template900Container extends React.Component {
    render() {
        return (
            <Core
                screenProvider={screenProvider}
                eventHandler={baseEventHandler}
                dataProvider={dataProvider}
                scrollLimit={2}
                {...this.props}
            >
                {(props) => <Template900Component {...props} />}
            </Core>
        );
    }
}
